import { EscalationInterface } from "@swivl-mono/types";
import { Button, ButtonColor, ButtonVariant } from "@swivl-mono/ui";
import { ImPhone } from "react-icons/im";
import { TbMicrophoneFilled, TbMicrophoneOff } from "react-icons/tb";

import CallModel, { CallStatus } from "../../../Models/CallModel/Call.Model";
import { UsersModel } from "../../../Models/Users/Users.Model";
import { EndCallIcon } from "../../Icons";

interface Props {
  escalation: EscalationInterface;
  callStatus: CallStatus;
  callerNumber: string | null;
  elapsedTime: string;
  isMuted: boolean;
}
export function VoiceCallBarInProgressView(props: Props) {
  const { escalation, callerNumber, elapsedTime, isMuted } = props;

  return (
    <>
      <div className="flex items-center gap-2">
        <ImPhone className="mr-2 size-4 animate-pulse text-yellow-700" />
        <span className="text-sm font-semibold">{callerNumber || "Unknown"}</span>
        <span className="text-sm text-grey-500">{elapsedTime}</span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          color={isMuted ? ButtonColor.YELLOW : ButtonColor.DARK_GREY}
          variant={ButtonVariant.ICON}
          onClick={() => {
            CallModel.toggleMute();
          }}
        >
          {isMuted ? (
            <TbMicrophoneOff className="size-5 fill-current transition-colors duration-300 group-hover:fill-grey-100" />
          ) : (
            <TbMicrophoneFilled className="size-5 fill-current transition-colors duration-300 group-hover:fill-grey-100" />
          )}
        </Button>
        <Button
          variant={ButtonVariant.ICON}
          color={ButtonColor.RED}
          onClick={() => {
            UsersModel.endTakeoverOfSession(escalation.sessionId, escalation.id);
          }}
        >
          <EndCallIcon
            classNames={{
              svg: "size-5",
              path: "group-hover:fill-grey-100 fill-current transition-colors duration-300"
            }}
          />
        </Button>
      </div>
    </>
  );
}
